
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34442',
  depVersions: {
  "documents-public-ui": "static-1.34442",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34447",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2108",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5570",
  "hs-test-utils": "static-1.7988",
  "hub-http": "static-1.6196",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11442",
  "I18n": "static-7.1616",
  "jasmine-immutable": "static-1.2995",
  "jasmine-runner": "static-1.6441",
  "lodash": "static-1.3",
  "quartz": "static-1.6993",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16643",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4742",
  "webpack-env": "static-1.54",
  "atom": "static-1.5046",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2472",
  "classnames": "static-2.10",
  "cssUtils": "static-1.784",
  "customer-data-filters-ui": "static-1.39660",
  "customer-data-objects": "static-1.7637",
  "customer-data-property-utils": "static-1.8062",
  "data-fetching-client": "static-1.9646",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4491",
  "flux-actions": "static-1.331",
  "FormsCommonComponents": "static-1.85762",
  "FormUrlGenerator": "static-2.4693",
  "foundations-components": "static-1.7881",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11749",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7133",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3820",
  "property-translator": "static-1.5375",
  "quartz-config": "static-1.771",
  "quartz-core": "static-1.6212",
  "quick-fetch": "static-1.3894",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5322",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8143",
  "reference-resolvers-lite": "static-1.8069",
  "report-customization-components": "static-1.13084",
  "reporting-enablement": "static-1.22821",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.88",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4626",
  "sales-content-partitioning": "static-1.8914",
  "SalesContentIndexUI": "static-3.9202",
  "sanitize": "static-1.4452",
  "sanitize-text": "static-1.8117",
  "self-service-api": "static-1.10221",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1722",
  "signup-constants": "static-1.18796",
  "signup-ui-lego-core": "static-1.20806",
  "signup-ui-url-generator": "static-2.8017",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4739",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10967",
  "ui-addon-i18n": "static-1.11126",
  "ui-addon-react-router-dom": "static-1.9518",
  "ui-addon-upgrades": "static-9.17947",
  "ui-asset-management-lib": "static-1.10987",
  "ui-images": "static-2.1145",
  "UIComponents": "static-3.8388",
  "usage-tracker": "static-1.7320",
  "usage-tracker-container": "static-1.7310",
  "usage-tracker-core": "static-1.7170",
  "usage-tracker-public": "static-1.7131",
  "viral-links-lib": "static-1.7031",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3382",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3270",
  "quartz-webpack": "static-1.3217",
  "ai-components-ui-library": "static-1.8868",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4838",
  "foundations-theming": "static-1.4392",
  "quartz-auth": "static-1.668",
  "ui-business-units-lib": "static-1.9023",
  "usage-tracker-session-replay": "static-1.5006",
  "foundations-theming-base": "static-1.3377",
  "HeadJS": "static-2.751",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3099",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.63",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4301",
  "csstype": "static-1.50",
  "quartz-head": "static-1.658",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7903",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3568",
  "persist-promise": "static-1.3672",
  "quartz-i18n": "static-1.668",
  "reporting-client-types": "static-1.2494",
  "foundations-components-legacy": "static-1.906",
  "hs-story-utils": "static-1.9402",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9898",
  "hubspotter-http": "static-1.4630",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7222",
  "crm-message-bus": "static-1.42917",
  "customer-data-filters-ui-msw-helpers": "static-1.22095",
  "customer-data-objects-ui-components": "static-1.12999",
  "customer-data-reference-ui-components": "static-1.13134",
  "customer-data-ui-utilities": "static-1.9800",
  "framework-builder-read-service-client": "static-1.3987",
  "framework-data-schema-quick-fetch": "static-1.6762",
  "framework-data-schema-resolvers": "static-1.6857",
  "inbound-db-properties-service-client": "static-1.3824",
  "multi-account-reference-resolvers": "static-1.952",
  "onboarding-tours": "static-1.16547",
  "reporting-datasets-permissions-lib": "static-1.13601",
  "ui-addon-teams": "static-1.21508",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68280",
  "customer-data-properties": "static-1.51447",
  "forms-ai-lib": "static-1.4278",
  "forms-utils-lib": "static-1.12526",
  "foundations-components-test-utils": "static-1.5364",
  "react-dnd-compat": "static-1.4594",
  "react-tinymce": "static-1.55164",
  "tinymce-config": "static-2.54290",
  "ui-gdpr-components": "static-1.10321",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4150",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.14",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1780",
  "ui-fonts": "static-1.704",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "mobile-manifest-mixins": "static-1.526",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.423",
  "quartz-test": "static-1.668",
  "quartz-tracking": "static-1.372",
  "batch-promise": "static-1.1515",
  "external-options-client-types": "static-1.4136",
  "react-colorpicker": "static-2.10184",
  "ui-addon-draggable-compat": "static-2.4229",
  "copilot-toolkit": "static-1.11067",
  "data-quality-ui-library": "static-1.12912",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6436",
  "reporting-action-components": "static-1.41227",
  "reporting-filters": "static-1.269",
  "reporting-insights-lib": "static-1.1657",
  "reporting-plugins": "static-1.10280",
  "ui-addon-opt": "static-4.8346",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25294",
  "hubspot-apollo-client": "static-1.4851",
  "bend-plugin-chirp-manifest": "static-1.36",
  "chirp-fetch": "static-1.1861",
  "sales-templates-service-types-lib": "static-1.4148",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5835",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4058",
  "nested-table": "static-1.201",
  "timezone-utils": "static-2.5219",
  "bender-build-tools": "static-1.3171",
  "chatspot-core": "static-1.21156",
  "bend-plugin-foundations-theming": "static-1.2875",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9896",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3775",
  "crm-pipelines-api-client-types": "static-1.4120",
  "multi-currency-client-types": "static-1.3669",
  "getting-started-shared-tasks": "static-1.18426",
  "growth-data-modal": "static-1.5386",
  "growth-onboarding-confetti": "static-1.3041",
  "growth-onboarding-next-action-utils": "static-1.1841",
  "navigation-components": "static-1.17954",
  "onboarding-tours-client": "static-1.4761",
  "onboarding-tours-utils": "static-1.613",
  "ui-shepherd-react": "static-3.10131",
  "ui-shepherd-tracker": "static-1.7512",
  "ui-universal-auth": "static-1.8946",
  "user-context": "static-1.5077",
  "cms-field-types": "static-1.4786",
  "content-icons-ui": "static-1.2218",
  "integrations-lib": "static-1.16023",
  "calling-global-api": "static-1.64425",
  "calling-internal-common": "static-1.31276",
  "calling-lifecycle-internal": "static-1.65807",
  "calling-lifecycle-messages": "static-1.58101",
  "commerce-products-lib": "static-1.9454",
  "crm-links": "static-1.6259",
  "customer-data-properties-shared-msw-handlers": "static-1.9225",
  "file-manager-components": "static-1.23543",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.126",
  "inbounddb-objects-service-types": "static-1.4201",
  "meetings-icalendar-utils-lib": "static-1.606",
  "object-builder-ui-client": "static-1.48642",
  "pipeline-validation-client-types": "static-1.3943",
  "property-value-citations": "static-1.2061",
  "pulse": "static-1.540",
  "smart-property-lib": "static-1.6785",
  "tiered-pricing": "static-1.1142",
  "ui-addon-iframeable": "static-1.9031",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19781",
  "tinymce-themes": "static-1.56260",
  "data-token-picker": "static-1.16359",
  "hub-http-contrib": "static-1.3016",
  "interframe": "static-3.4735",
  "tinymce-data": "static-1.40375",
  "tinymce-plugins": "static-1.57404",
  "ui-addon-sales-email": "static-1.5185",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5537",
  "magpie-types": "static-1.4997",
  "simple-logging-lib": "static-1.3023",
  "content-assistance-lib": "static-1.7710",
  "dashboard-lib": "static-1.81408",
  "ExportDialog": "static-6.10366",
  "hubspot-prosemirror": "static-1.18167",
  "hubspot-prosemirror-plugins": "static-1.18159",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8678",
  "campaign-roi-lib": "static-1.9001",
  "feedback-loader": "static-1.29245",
  "apollo-link-hub-http": "static-2.4624",
  "hubspot-apollo-cache": "static-1.310",
  "purchase-motions-api": "static-1.5838",
  "trials-service-types": "static-1.3877",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.147",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1915",
  "growth-onboarding-next-action-components": "static-1.1869",
  "user-context-client": "static-1.4586",
  "idb-keyval": "static-1.43",
  "nest": "static-1.201",
  "reactive-lib": "static-1.696",
  "unified-auth-core-lib": "static-1.742",
  "getting-started-shared-tasks-store": "static-1.17544",
  "integrations-error-boundary-lib": "static-1.13438",
  "integrations-tracking-lib": "static-1.5573",
  "native-integrations-shared-strings": "static-1.7757",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10344",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.460",
  "calling-error-reporting": "static-1.31283",
  "shared-worker-versioning": "static-1.11012",
  "calling-usage-tracker": "static-1.6517",
  "voice-sms-access-library": "static-1.867",
  "customer-data-tracking": "static-1.6862",
  "commerce-permissions": "static-1.741",
  "products-iframe-lib": "static-1.7856",
  "products-ui-components-shared-msw-handlers": "static-1.10280",
  "location-customization-utils-lib": "static-1.9168",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4128",
  "video-components-external": "static-1.11179",
  "video-data-lib": "static-1.34837",
  "bend-plugin-pulse": "static-1.43",
  "directed-graph": "static-1.909",
  "event-emitter": "static-1.922",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.151",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9981",
  "fsm": "static-1.3705",
  "policy-lib": "static-1.6752",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10044",
  "navigation-messaging": "static-1.7281",
  "FileManagerLib": "static-1.39183",
  "NamespacedHubStyle": "static-2.9039",
  "FileManagerCore": "static-1.39042",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12393",
  "layout-dnd-utils": "static-1.11368",
  "react-codemirror": "static-1.10599",
  "ui-addon-emoji-picker": "static-1.9863",
  "ui-brand-identity-lib": "static-1.15151",
  "ui-addon-video-player": "static-1.8677",
  "ui-coaching-tips": "static-1.28473",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23457",
  "EmailSignatureEditor": "static-1.24310",
  "breeze-engine-lib": "static-1.532",
  "InboxConnectUtils": "static-4.14737",
  "universal-page-editor-lib": "static-1.2987",
  "google-sheets-integration-lib": "static-1.154",
  "microsoft-drive-integration-lib": "static-1.270",
  "calling-orchestration-schema": "static-1.35644",
  "sales-views-client-types": "static-1.4238",
  "crm-record-cards-service-types": "static-1.3586",
  "content-media-composition-data-lib": "static-1.12166",
  "content-media-compositions": "static-2.16173",
  "media-bridge-lib": "static-1.18877",
  "trellis-story-utils": "static-1.4490",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5875",
  "FileManagerImages": "static-1.36694",
  "video-components": "static-1.13182",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4511",
  "video-embed": "static-1.35671",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68355",
  "layout-data-lib": "static-1.9693",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6556",
  "commerce-tours-lib": "static-1.6043",
  "growth-onboarding-reliability": "static-1.5057",
  "sales-checkout-service-client": "static-1.3613",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21625",
  "sales-email-signature-service-client": "static-1.3817",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22006",
  "outpost": "static-1.4160",
  "advanced-menus-core": "static-1.15088",
  "advanced-menus-lib": "static-1.12033",
  "ui-memberships-settings-lib": "static-1.33970",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15087",
  "simple-menus-lib": "static-1.16604"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34442",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34447",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2108",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5570",
  "hs-test-utils": "/hs-test-utils/static-1.7988",
  "hub-http": "/hub-http/static-1.6196",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11442",
  "I18n": "/I18n/static-7.1616",
  "jasmine-immutable": "/jasmine-immutable/static-1.2995",
  "jasmine-runner": "/jasmine-runner/static-1.6441",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6993",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16643",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.88",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4742",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5046",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2472",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.784",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39660",
  "customer-data-objects": "/customer-data-objects/static-1.7637",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8062",
  "data-fetching-client": "/data-fetching-client/static-1.9646",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4491",
  "flux-actions": "/flux-actions/static-1.331",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85762",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4693",
  "foundations-components": "/foundations-components/static-1.7881",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11749",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7133",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3820",
  "property-translator": "/property-translator/static-1.5375",
  "quartz-config": "/quartz-config/static-1.771",
  "quartz-core": "/quartz-core/static-1.6212",
  "quick-fetch": "/quick-fetch/static-1.3894",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5322",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8143",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8069",
  "report-customization-components": "/report-customization-components/static-1.13084",
  "reporting-enablement": "/reporting-enablement/static-1.22821",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.88",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4626",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8914",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9202",
  "sanitize": "/sanitize/static-1.4452",
  "sanitize-text": "/sanitize-text/static-1.8117",
  "self-service-api": "/self-service-api/static-1.10221",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1722",
  "signup-constants": "/signup-constants/static-1.18796",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20806",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8017",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4739",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10967",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11126",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9518",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17947",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10987",
  "ui-images": "/ui-images/static-2.1145",
  "UIComponents": "/UIComponents/static-3.8388",
  "usage-tracker": "/usage-tracker/static-1.7320",
  "usage-tracker-container": "/usage-tracker-container/static-1.7310",
  "usage-tracker-core": "/usage-tracker-core/static-1.7170",
  "usage-tracker-public": "/usage-tracker-public/static-1.7131",
  "viral-links-lib": "/viral-links-lib/static-1.7031",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3382",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3270",
  "quartz-webpack": "/quartz-webpack/static-1.3217",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8868",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4838",
  "foundations-theming": "/foundations-theming/static-1.4392",
  "quartz-auth": "/quartz-auth/static-1.668",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9023",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5006",
  "foundations-theming-base": "/foundations-theming-base/static-1.3377",
  "HeadJS": "/HeadJS/static-2.751",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3099",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.63",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4301",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.658",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7903",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3568",
  "persist-promise": "/persist-promise/static-1.3672",
  "quartz-i18n": "/quartz-i18n/static-1.668",
  "reporting-client-types": "/reporting-client-types/static-1.2494",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.906",
  "hs-story-utils": "/hs-story-utils/static-1.9402",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9898",
  "hubspotter-http": "/hubspotter-http/static-1.4630",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7222",
  "crm-message-bus": "/crm-message-bus/static-1.42917",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22095",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12999",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13134",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9800",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3987",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6762",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6857",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3824",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.952",
  "onboarding-tours": "/onboarding-tours/static-1.16547",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13601",
  "ui-addon-teams": "/ui-addon-teams/static-1.21508",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68280",
  "customer-data-properties": "/customer-data-properties/static-1.51447",
  "forms-ai-lib": "/forms-ai-lib/static-1.4278",
  "forms-utils-lib": "/forms-utils-lib/static-1.12526",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5364",
  "react-dnd-compat": "/react-dnd-compat/static-1.4594",
  "react-tinymce": "/react-tinymce/static-1.55164",
  "tinymce-config": "/tinymce-config/static-2.54290",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10321",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4150",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.14",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1780",
  "ui-fonts": "/ui-fonts/static-1.704",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.526",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.423",
  "quartz-test": "/quartz-test/static-1.668",
  "quartz-tracking": "/quartz-tracking/static-1.372",
  "batch-promise": "/batch-promise/static-1.1515",
  "external-options-client-types": "/external-options-client-types/static-1.4136",
  "react-colorpicker": "/react-colorpicker/static-2.10184",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4229",
  "copilot-toolkit": "/copilot-toolkit/static-1.11067",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12912",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6436",
  "reporting-action-components": "/reporting-action-components/static-1.41227",
  "reporting-filters": "/reporting-filters/static-1.269",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1657",
  "reporting-plugins": "/reporting-plugins/static-1.10280",
  "ui-addon-opt": "/ui-addon-opt/static-4.8346",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25294",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4851",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.36",
  "chirp-fetch": "/chirp-fetch/static-1.1861",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4148",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5835",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4058",
  "nested-table": "/nested-table/static-1.201",
  "timezone-utils": "/timezone-utils/static-2.5219",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "chatspot-core": "/chatspot-core/static-1.21156",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2875",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9896",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3775",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4120",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3669",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18426",
  "growth-data-modal": "/growth-data-modal/static-1.5386",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3041",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1841",
  "navigation-components": "/navigation-components/static-1.17954",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4761",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.613",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10131",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7512",
  "ui-universal-auth": "/ui-universal-auth/static-1.8946",
  "user-context": "/user-context/static-1.5077",
  "cms-field-types": "/cms-field-types/static-1.4786",
  "content-icons-ui": "/content-icons-ui/static-1.2218",
  "integrations-lib": "/integrations-lib/static-1.16023",
  "calling-global-api": "/calling-global-api/static-1.64425",
  "calling-internal-common": "/calling-internal-common/static-1.31276",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65807",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58101",
  "commerce-products-lib": "/commerce-products-lib/static-1.9454",
  "crm-links": "/crm-links/static-1.6259",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9225",
  "file-manager-components": "/file-manager-components/static-1.23543",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.126",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4201",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.606",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48642",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3943",
  "property-value-citations": "/property-value-citations/static-1.2061",
  "pulse": "/pulse/static-1.540",
  "smart-property-lib": "/smart-property-lib/static-1.6785",
  "tiered-pricing": "/tiered-pricing/static-1.1142",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9031",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19781",
  "tinymce-themes": "/tinymce-themes/static-1.56260",
  "data-token-picker": "/data-token-picker/static-1.16359",
  "hub-http-contrib": "/hub-http-contrib/static-1.3016",
  "interframe": "/interframe/static-3.4735",
  "tinymce-data": "/tinymce-data/static-1.40375",
  "tinymce-plugins": "/tinymce-plugins/static-1.57404",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5185",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5537",
  "magpie-types": "/magpie-types/static-1.4997",
  "simple-logging-lib": "/simple-logging-lib/static-1.3023",
  "content-assistance-lib": "/content-assistance-lib/static-1.7710",
  "dashboard-lib": "/dashboard-lib/static-1.81408",
  "ExportDialog": "/ExportDialog/static-6.10366",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18167",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18159",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8678",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9001",
  "feedback-loader": "/feedback-loader/static-1.29245",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4624",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.310",
  "purchase-motions-api": "/purchase-motions-api/static-1.5838",
  "trials-service-types": "/trials-service-types/static-1.3877",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.147",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1915",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1869",
  "user-context-client": "/user-context-client/static-1.4586",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.201",
  "reactive-lib": "/reactive-lib/static-1.696",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.742",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17544",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13438",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5573",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7757",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10344",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.460",
  "calling-error-reporting": "/calling-error-reporting/static-1.31283",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11012",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6517",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.867",
  "customer-data-tracking": "/customer-data-tracking/static-1.6862",
  "commerce-permissions": "/commerce-permissions/static-1.741",
  "products-iframe-lib": "/products-iframe-lib/static-1.7856",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10280",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9168",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4128",
  "video-components-external": "/video-components-external/static-1.11179",
  "video-data-lib": "/video-data-lib/static-1.34837",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.43",
  "directed-graph": "/directed-graph/static-1.909",
  "event-emitter": "/event-emitter/static-1.922",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.151",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9981",
  "fsm": "/fsm/static-1.3705",
  "policy-lib": "/policy-lib/static-1.6752",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10044",
  "navigation-messaging": "/navigation-messaging/static-1.7281",
  "FileManagerLib": "/FileManagerLib/static-1.39183",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9039",
  "FileManagerCore": "/FileManagerCore/static-1.39042",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12393",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11368",
  "react-codemirror": "/react-codemirror/static-1.10599",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9863",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15151",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8677",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28473",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23457",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24310",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.532",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14737",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2987",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.154",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.270",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35644",
  "sales-views-client-types": "/sales-views-client-types/static-1.4238",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3586",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12166",
  "content-media-compositions": "/content-media-compositions/static-2.16173",
  "media-bridge-lib": "/media-bridge-lib/static-1.18877",
  "trellis-story-utils": "/trellis-story-utils/static-1.4490",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5875",
  "FileManagerImages": "/FileManagerImages/static-1.36694",
  "video-components": "/video-components/static-1.13182",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4511",
  "video-embed": "/video-embed/static-1.35671",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68355",
  "layout-data-lib": "/layout-data-lib/static-1.9693",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6556",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6043",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5057",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3613",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21625",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3817",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "outpost": "/outpost/static-1.4160",
  "advanced-menus-core": "/advanced-menus-core/static-1.15088",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12033",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33970",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15087",
  "simple-menus-lib": "/simple-menus-lib/static-1.16604"
}
};
